<template>
  <div class="main">
    <!-- 客户信息维护 -->
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow">
        <el-icon @click="emits('changePage', 'maintence_home')"><Back /></el-icon>
        <el-breadcrumb separator-icon="arrowRight">
          <el-breadcrumb-item>开票信息维护</el-breadcrumb-item>
          <el-breadcrumb-item style="font-weight: 700">客户信息维护</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <div class="content">
      <khbm-maintence />
    </div>
  </div>
</template>

<script setup name="Maintence/khbm">
import khbmMaintence from '../cmp/khbmMaintence.vue';

const emits = defineEmits(['changePage']);
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: #f6f7fb;
  font-size: 16px;
  .header-block {
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      column-gap: 0.1rem;
      :deep(.el-breadcrumb) {
        .el-breadcrumb__item {
          font-size: 0.16rem;
          .el-breadcrumb__inner {
            font-weight: 400;
            line-height: 0.6rem;
            color: #333;
          }
          &:last-child {
            .el-breadcrumb__inner {
              font-weight: 700;
            }
          }
        }
      }
    }
  }

  .content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.2rem;
    background: #fff content-box;
  }
}
</style>
